export default "__VITE_ASSET__DagvvBAw__"